export interface LoginFormData {
    username: string;
    password: string;
}
